import { CANCEL_BOOKING_V2, CANCEL_BOOKING_V2_SUCCESS, CANCEL_BOOKING_V2_ERROR, CANCEL_BOOKING_V2_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CancelBookingV2 = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_BOOKING_V2:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CANCEL_BOOKING_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CANCEL_BOOKING_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CANCEL_BOOKING_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CancelBookingV2;
